import React from "react";

const ShipmentRackIcon = React.forwardRef(
  (
    {
      color = "currentColor",
      size = 24,
      strokeWidth = 2,
      className = "",
      ...props
    },
    ref
  ) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <rect x="5.05" y="2.21" width="13.9" height="15.43" rx="2" />
      <circle cx="16.95" cy="19.79" r="2" />
      <circle cx="7.05" cy="19.79" r="2" />
      <line
        x1="5.05"
        y1="7.36"
        x2="18.95"
        y2="7.36"
        strokeLinecap="butt"
        strokeLinejoin="miter"
      />
      <line
        x1="4.78"
        y1="12.5"
        x2="18.68"
        y2="12.5"
        strokeLinecap="butt"
        strokeLinejoin="miter"
      />
    </svg>
  )
);

ShipmentRackIcon.displayName = "ShipmentRackIcon";

export default ShipmentRackIcon;
